import React from "react";
import GeneralSection from "../../newComponents/generalSection";
import ImgixFluidImage from "../../newComponents/ImgixFluidImage";

const logoStrip = ({ block, }) => (
  <GeneralSection>
    <div className={`flex my-8`}>
      {block.images.map((image, index) => (
        <a key={`logo-strip-${block.id}-item-${index}`} href={image.assetLinkUrl} className="w-full h-full flex justify center items-center">
          <ImgixFluidImage attribution={image.attribution} image={image} ar={image.width / image.height} focalPoint={image.focalPoint}/>
        </a>
      ))}
    </div>
  </GeneralSection>
)

export default logoStrip;
